<div _ngcontent-ng-c3508520752="" class="mb-3">
    <div>
        <div class="mb-4 flex align-items-center white-space-nowrap overflow-x-auto gap-2">
            <div class="mt-0 mb-0 py-2 px-3 p-message p-message-info">
                <span>Ajuda com </span>
                <span class="font-bold">{{ text }}</span><span>?</span>
            </div>

            <button style="flex: 0 0 auto;" class="py-2 px-3 p-element p-ripple p-button p-component" target="_blank"
                >
                ▶ Ver vídeo
            </button>

            <button style="flex: 0 0 auto;" class="py-2 px-3 p-element p-ripple p-button-outlined p-button p-component"
                target="_blank" >
                <i class="pi pi-compass mr-1"></i>
                Ver tour
            </button>
        </div>
    </div>
</div>